import {DG_axios} from "../../custom/axios";


const baseURL = `/o/dogoo/customer`

export async function getAllCustomers(page, pageSize, search) {

    const response = await DG_axios.get(baseURL + "/get-list", {
            params: {
                page,
                pageSize,
                search
            }
        }
    )
    return response?.data.result || []
}

export async function getCustomerById(id) {
    const response = await DG_axios.get(baseURL + "/get/" + id)
    return response?.data.result || []
}
export async function updateCustomer(id, data) {
    const response = await DG_axios.put(baseURL + "/update/" + id, data)
    return response?.data.result || []
}

export async function deleteCustomer(id) {
    const response = await DG_axios.delete(baseURL + "/delete/" + id)
    return response?.data.result || []
}
export async function addCustomer(data) {
    const response = await DG_axios.post(baseURL + "/add" , data)
    return response?.data.result || []
}

export async function getAutocodeCustomer(name) {
    const response = await DG_axios.get(baseURL + "/get-auto-code" , {
        params: {
            name
        }
    })
    return response?.data.result || []
}

export async function getAllCustomerSearch(search) {

    const response = await DG_axios.get(baseURL + "/get-list-search", {
            params: {
                search
            }
        }
    )
    return response?.data.result || []
}
